<template>
  <div>
    <div class="pxkeji-right-box">
      <a-row>
        <a-col :span="3" class="title"></a-col>
        <a-col :span="10" class="title">上午</a-col>
        <a-col :span="10" class="title">下午</a-col>
      </a-row>
      <a-row v-for="(item,index) in data" :key="index">
        <a-col :span="3" class="title" v-if="item.time=='monday'">周一</a-col>
        <a-col :span="3" class="title" v-else-if="item.time=='tuesday'">周二</a-col>
        <a-col :span="3" class="title" v-else-if="item.time=='wednesday'">周三</a-col>
        <a-col :span="3" class="title" v-else-if="item.time=='thursday'">周四</a-col>
        <a-col :span="3" class="title" v-else-if="item.time=='friday'">周五</a-col>
        <a-col :span="3" class="title" v-else-if="item.time=='saturday'">周六</a-col>
        <a-col :span="3" class="title" v-else-if="item.time=='sunday'">周日</a-col>

        <a-col :span="10" class="item">
          <a-col :span="20">{{item.am}}</a-col>
          <a-col :span="4" class="edit" @click="handleEdit(item.am,index,1)">修改</a-col>
        </a-col>
        <a-col :span="10" class="item">
          <a-col :span="20">{{item.pm}}</a-col>
          <a-col :span="4" class="edit" @click="handleEdit(item.pm,index,2)">修改</a-col>
        </a-col>
      </a-row>
    </div>
    <a-row :gutter="24">
      <a-col :span="24" :style="{ textAlign: 'center' }">
        <a-button type="primary" @click="choseBack">确定并返回</a-button>
      </a-col>
    </a-row>
    <!--修改-->
    <a-modal title="修改" v-model="edit.visible" width="40%" :footer="false" destroyOnClose>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="是否休息" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-switch
            v-model="info.isstatus"
            checkedChildren="不休息"
            unCheckedChildren="休息"
            v-decorator="[
          'isstatus',
          {rules: []}
        ]"
          />
        </a-form-item>
        <a-form-item
          label="时间安排"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 19 }"
          v-if="info.isstatus"
        >
          <a-time-picker @change="onChangeStart" v-if="!edit.starttime"  format="HH:mm" disabled />
          <a-time-picker
            @change="onChangeStart"
            format="HH:mm"
            v-decorator="[ 'starttime', {rules: [],initialValue:this.$moment(edit.starttime, 'HH:mm')} ]"
            v-else
            disabled 
          />
          <span>~</span>
          <a-time-picker @change="onChangeEnd" v-if="!edit.endtime"  format="HH:mm" disabled />
          <a-time-picker
            @change="onChangeEnd"
            format="HH:mm"
            v-decorator="[ 'endtime', {rules: [],initialValue:this.$moment(edit.endtime, 'HH:mm')} ]"
            v-else
            disabled 
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" html-type="submit">提交</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
var that;

export default {
  props: {
    list: String
  },
  name: "userlist",
  data() {
    return {
      form: this.$form.createForm(this),
      expand: false, //高级搜索
      isloading: false,
      data: [],
      edit: {
        visible: false,
        index: 0,
        type: 1, //上午/下午
        time: "",
        starttime: "",
        endtime: ""
      },
      info: {
        isstatus: false
      }
    };
  },
  components: {},
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      console.log(this.list);
      var _datas = this.list?JSON.parse(this.list):"";
      var newData = [];
      for (var i in _datas) {
        newData.push({
          time: i,
          am: _datas[i].am,
          pm: _datas[i].pm
        });
      }
      this.data = newData;
      console.log(this.data);
    });
  },
  watch: {
    selectRows: function() {
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    handleEdit(time, index, type) {
      this.edit.visible = true;
      this.edit.index = index;
      if (time == "休息") {
        this.info.isstatus = false;
      } else {
        this.info.isstatus = true;
        this.edit.time = time;
        this.edit.starttime = time.split("~")[0];
        this.edit.endtime = time.split("~")[1];
      }
      if (type == 1) {
        this.edit.type = 1;
        this.edit.starttime = "09:00";
        this.edit.endtime = "12:00";
      } else {
        this.edit.type = 2;
        this.edit.starttime = "14:00";
        this.edit.endtime = "18:00";
      }
    },
    //时间选择
    onChangeStart(time, timeString) {
      this.edit.starttime = timeString;
    },
    //时间选择
    onChangeEnd(time, timeString) {
      this.edit.endtime = timeString;
    },
    /**修改保存 */
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          that.edit.visible = false;
          if (values.isstatus) {
            //不休息
            if (that.edit.type == 1) {
              //上午
              that.data[that.edit.index].am =
                that.edit.starttime + "~" + that.edit.endtime;
            } else {
              that.data[that.edit.index].pm =
                that.edit.starttime + "~" + that.edit.endtime;
            }
          } else {
            if (that.edit.type == 1) {
              //上午
              that.data[that.edit.index].am = "休息";
            } else {
              that.data[that.edit.index].pm = "休息";
            }
          }
        }
      });
    },
    //返回
    choseBack() {
      this.$emit("callbackMethod", this.data);
    }
  }
};
</script>

<style scoped>
.title,
.item {
  background: #fafafa;
  transition: background 0.3s ease;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  border-bottom: 1px solid #e8e8e8;
  text-align: center;
  height: 40px;
  line-height: 40px;
}
.item {
  background: none;
}
.edit {
  color: #1890ff;
  cursor: pointer;
}
</style>

